// Pobanz Orthodontics (UT) - two offices: Pleasant View + South Ogden.
// Backend: bondLocations.ts POBANZ_PLEASANT_VIEW / POBANZ_SOUTH_OGDEN
// (brandId "pobanz", catalog d00e71d7, Edge loc 2/4, procedure 489, DB 375).
// Native booking via the ortho2-newpatient backend (WCF intake disabled - login
// not provisioned on DB 375). English-only.
import type { BrandConfig } from "./types";

export const pobanz: BrandConfig = {
  slug: "pobanz",
  brandId: "pobanz",
  brandName: "Pobanz Orthodontics",
  logo: "https://www.webracem.com/wp-content/uploads/2022/12/cropped-pobanz-logo.webp",
  phone: "(801) 627-0500",
  phoneHref: "tel:+18016270500",
  theme: { primary: "#187FC0", primaryDark: "#0F4E78" }, // scoured 2026-07-14 webracem.com
  locales: ["en", "es"], // site exposes es-PR health-history form
  locations: {
    POBANZ_PLEASANT_VIEW: {
      id: "POBANZ_PLEASANT_VIEW",
      name: "Pleasant View",
      addressLines: ["2717 US-89, Ste 300", "Pleasant View, UT 84414"],
      mapsUrl: "https://maps.google.com/?q=2717+US-89+Ste+300+Pleasant+View+UT+84414",
      timezone: "America/Denver",
    },
    POBANZ_SOUTH_OGDEN: {
      id: "POBANZ_SOUTH_OGDEN",
      name: "South Ogden",
      addressLines: ["1508 Skyline Drive, Ste 200", "South Ogden, UT 84405"],
      mapsUrl: "https://maps.google.com/?q=1508+Skyline+Drive+Ste+200+South+Ogden+UT+84405",
      timezone: "America/Denver",
    },
  },
  locationAliases: {
    PLEASANT_VIEW: "POBANZ_PLEASANT_VIEW",
    SOUTH_OGDEN: "POBANZ_SOUTH_OGDEN",
  },
};
